import React from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';

import AuthUtility from './auth/AuthUtility';

import logo from '../../assets/frontend/images/logo.png';
import podcast_icon_image from '../../assets/frontend/images/podcast_icon.png';

const Radio = () => {

	//logout should be its own component
	const navHistory = useNavigate();

	function handleAlbum(title_private, type) {
		if (!title_private || title_private === '' || !type || type === '') {
			return;
		}
		if (AuthUtility.isLoggedIn()) {
			navHistory('/member/album/' + title_private + '/' + type);
		} else {
			//user not authenticated on server so remove from local storage
			AuthUtility.clearAuthData();
			navHistory('/album/' + title_private + '/' + type);
		}
	}

	function handleDonation(title_private, type) {
		if (!title_private || title_private === '' || !type || type === '') {
			return;
		}
		navHistory('/donation/' + title_private + '/' + type);
	}

	function handleJoin() {
		navHistory('/register');
	}

	return (
		<div className="body-content bg-fff pt-80l-70m-60s pb-120">

			<div className="panel large pt-20l-10s">
				<div className="grid-x">
					<div className="large-12 medium-12 small-12 cell text-left">
						<div className="font-libre-baskerville font-size-24l-20m-16s font-weight-800 bb1-555 pb-5">Radio</div>
					</div>
				</div>
			</div>

			<div className="panel large pt-20l-10s">
				<div className="grid-x bg-fafafa b1-ddd p-20l-10s">
					<div className="large-12 medium-12 small-12 cell">
						<div className="font-libre-baskerville  font-size-18 font-weight-700 text-left hide-for-small-only">Title</div>
						<div className="font-libre-baskerville  font-size-18 font-weight-700 text-center show-for-small-only">Title</div>
						<div className="font-source-sans font-size-18l-16m-14s font-weight-500 line-height-120per justify pt-20">
						Content coming soon!
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default Radio;